import {IndividualAccountPurpose, IndividualAccountPurposeMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIndividualAccountPurposeProps {
	accountPurpose?: IndividualAccountPurpose
	setAccountPurpose: (value: IndividualAccountPurpose) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: IndividualAccountPurpose) => void
	className?: string
}

export function EditableIndividualAccountPurposeField(props: EditableIndividualAccountPurposeProps) {
	if (props.accountPurpose) {
		return (
			<Editable
				label="Account Purpose"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setAccountPurpose}
				value={props.accountPurpose}
				initial={props.accountPurpose}
				update={props.update}
				className={props.className}
				possibleValues={IndividualAccountPurposeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
